// extracted by mini-css-extract-plugin
export default {"activity_filter_row":"CaseActivityFilter_activity_filter_row__Y3slF","activity_filter_label":"CaseActivityFilter_activity_filter_label__ZVKPs"};